export default "__VITE_ASSET__DdbWaaxs__"